export default __webpack_public_path__ + "static/media/pdf_doc.8a85e237.svg";